import { jsx as _jsx } from "react/jsx-runtime";
//Components
import { Button } from '@kubit/web-ui-product-components';
// Hooks
import { ButtonHook } from './hooks/button.hook';
//Configurations
import { buttonConfigurationPropsConversion } from './configurations/button.configuration';
const ButtonComponent = (props) => {
    const { onClick, analytics } = props;
    const { onEventClick } = ButtonHook({ onClick, analytics });
    return _jsx(Button, { ...buttonConfigurationPropsConversion({ ...props, onEventClick }) });
};
export { ButtonComponent };
//# sourceMappingURL=button.component.js.map